import { Button, Spinner } from "react-bootstrap";

const ButtonSpinner = ({ children, type, onClick, isLoading }) => {
  return (
    <Button type={type} onClick={onClick} disabled={isLoading}>
      {isLoading ? [<Spinner animation="border"/>,' ',children] : children}
    </Button>
  );
};

export default ButtonSpinner;
